"use client";
import React from "react";
import AnimatedSection from "./AnimatedSection";

const SponsorsSection: React.FC = () => {
  const basePartners = [
    {
      name: "Stanford Community",
      href: "https://community.stanford.edu/",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Stanford_wordmark_%282012%29.svg/500px-Stanford_wordmark_%282012%29.svg.png",
    },
    {
      name: "Alzheimer's Association",
      href: "https://www.alz.org/",
      logo: "https://www.alz.org/getmedia/da2a242a-c54e-4af7-9704-0c0fc2523cdb/alz-notagline-logo-ogmetaimage.jpg",
    },
    {
      name: "Lewy Body Resource Center",
      href: "https://lewybodyresourcecenter.org/",
      logo: "https://lewybodyresourcecenter.org/wp-content/uploads/2017/04/logo-1.png",
    },
    {
      name: "Neuravia",
      href: "https://neuravia.tech/about-us/",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5l49pg2mtOQPEH1Rvk7CHAw0H7nxwt944YYphrKSdgQ&s",
    },
  ];
  // Duplicate for a seamless infinite ticker.
  const partners = [...basePartners, ...basePartners];

  return (
    <section data-component-id="src/components/SponsorsSection.tsx:32:4" data-component-path="src/components/SponsorsSection.tsx" data-component-line="32" data-component-end-line="71" data-component-file="SponsorsSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22bg-%5B%23291533%5D%20hidden%22%7D" className="bg-[#291533] hidden" style={{ padding: "100px 0" }}>
      <div data-component-id="src/components/SponsorsSection.tsx:33:6" data-component-path="src/components/SponsorsSection.tsx" data-component-line="33" data-component-end-line="70" data-component-file="SponsorsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-14%22%7D" className="flex flex-col gap-14">
        {/* Title */}
        <AnimatedSection data-component-id="src/components/SponsorsSection.tsx:35:8" data-component-path="src/components/SponsorsSection.tsx" data-component-line="35" data-component-end-line="42" data-component-file="SponsorsSection.tsx" data-component-name="AnimatedSection" data-component-content="%7B%22elementName%22%3A%22AnimatedSection%22%2C%22className%22%3A%22text-center%20px-8%22%7D" delay={0} className="text-center px-8">
          <p data-component-id="src/components/SponsorsSection.tsx:36:10" data-component-path="src/components/SponsorsSection.tsx" data-component-line="36" data-component-end-line="38" data-component-file="SponsorsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-satoshi%20font-medium%20text-%5B%23ffd166%5D%20text-sm%20%20tracking-%5B0.2em%5D%20mb-2%22%2C%22textContent%22%3A%22Trusted%20Collaborators%22%7D" className="font-satoshi font-medium text-[#ffd166] text-sm  tracking-[0.2em] mb-2">
            Trusted Collaborators
          </p>
          <p data-component-id="src/components/SponsorsSection.tsx:39:10" data-component-path="src/components/SponsorsSection.tsx" data-component-line="39" data-component-end-line="41" data-component-file="SponsorsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-geist%20font-semibold%20text-white%20text-2xl%22%2C%22textContent%22%3A%22Collaborations%22%7D" className="font-geist font-semibold text-white text-2xl">
            Collaborations
          </p>
        </AnimatedSection>

        {/* Ticker */}
        <div data-component-id="src/components/SponsorsSection.tsx:45:8" data-component-path="src/components/SponsorsSection.tsx" data-component-line="45" data-component-end-line="69" data-component-file="SponsorsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22ticker-wrapper%22%7D" className="ticker-wrapper">
          <div data-component-id="src/components/SponsorsSection.tsx:46:10" data-component-path="src/components/SponsorsSection.tsx" data-component-line="46" data-component-end-line="68" data-component-file="SponsorsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22ticker-track%22%7D"
            className="ticker-track"
            style={{ gap: "72px", alignItems: "center" }}
          >
            {partners.map((partner, i) => (
              <a data-component-id="src/components/SponsorsSection.tsx:51:14" data-component-path="src/components/SponsorsSection.tsx" data-component-line="51" data-component-end-line="66" data-component-file="SponsorsSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22flex-shrink-0%20flex%20items-center%20justify-center%20bg-white%20rounded-2xl%20px-8%20h-24%20opacity-90%20hover%3Aopacity-100%20transition-opacity%22%7D"
                key={i}
                href={partner.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={partner.name}
                className="flex-shrink-0 flex items-center justify-center bg-white rounded-2xl px-8 h-24 opacity-90 hover:opacity-100 transition-opacity"
                style={{ minWidth: "220px" }}
              >
                <img data-component-id="src/components/SponsorsSection.tsx:60:16" data-component-path="src/components/SponsorsSection.tsx" data-component-line="60" data-component-end-line="65" data-component-file="SponsorsSection.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22className%22%3A%22max-h-12%20max-w-%5B170px%5D%20w-auto%20object-contain%22%7D"
                  src={partner.logo}
                  alt={`${partner.name} logo`}
                  className="max-h-12 max-w-[170px] w-auto object-contain"
                  loading="lazy"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SponsorsSection;
